import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { SET_ACCESS_ERROR } from 'redux/slices/authentication';
import { Button, Input, Tooltip } from 'ui/atoms';
import MainFont from 'ui/typography/mainFont';
import validator from 'utils/regex-validator';

import {
  ForgotButtonWrapper,
  ForgotPasswordText,
  ForgotPasswordTitle
} from './style';

const ForgotPasswordWrapper = ({ resetForgotPassword, setError, error }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState();
  const [emailError, setEmailError] = useState();

  const onSubmit = () => {
    if (!validator.email(email?.trim())) {
      setError(t('email_not_valid'));
    } else {
      setError('');
      resetForgotPassword(email?.trim());
    }
  };

  useEffect(() => {
    if (email && !validator.email(email?.trim())) {
      setEmailError(true);
    } else {
      setEmailError(false);
    }
  }, [email]);

  const onSubmitKeyboard = event => {
    if (event.key === 'Enter') {
      onSubmit();
    }
  };

  const isDisabled = () => !email || emailError;

  return (
    <>
      <ForgotPasswordTitle>
        <MainFont configuration={{ fontSize: 24 }} type="3">
          {t('forgot_password')}
        </MainFont>
      </ForgotPasswordTitle>
      <ForgotPasswordText>
        <MainFont configuration={{ fontSize: 14 }} type="3">
          {t('insert_mail_forgot_password')}
        </MainFont>
      </ForgotPasswordText>

      <Input
        value={email}
        placeholder={`${t('enter_email')}`}
        variant="login"
        onChange={e => setEmail(e.target.value)}
        onKeyDown={onSubmitKeyboard}
        status={error || emailError ? 'invalid' : ''}
        data-tip={
          emailError
            ? `<h1 style='color:red;'>${t('email_not_valid')}.</h1>`
            : `<h1 style='color:red;'>${t('can_not_find_email')}</h1>`
        }
        data-html
        data-for="email-not-valid"
      />
      {(emailError || error) && <Tooltip id="email-not-valid" />}
      <ForgotButtonWrapper>
        <Button variant="login" disabled={isDisabled()} onClick={onSubmit}>
          {t('submit')}
        </Button>
      </ForgotButtonWrapper>
    </>
  );
};

ForgotPasswordWrapper.propTypes = {
  resetForgotPassword: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  resetForgotPasswordKeyboard: PropTypes.func,
  error: PropTypes.string
};

export default connect(
  () => ({}),
  dispatch => ({
    setError: payload => dispatch(SET_ACCESS_ERROR(payload))
  })
)(ForgotPasswordWrapper);
